import { getProductFilter } from '~/features/ProductList/utils';
import useBrandEntities from '~/services/loop54/hooks/useBrandEntities';
import { Loop54ProductAttributes } from '~/services/loop54/types';
import { reduceLoop54Product } from '~/services/loop54/utils';

type Arguments = {
    brand: string;
    onlyShowInStock?: boolean;
};

type filter = {
    type: string;
    attributeName?: Loop54ProductAttributes;
    value: string | boolean;
};

export default function useBrandResults({ brand, onlyShowInStock }: Arguments) {
    const filters: filter[] = [
        getProductFilter(),

        {
            type: 'attribute',
            attributeName: Loop54ProductAttributes.Brand,
            value: brand,
        },
    ];

    if (onlyShowInStock) {
        filters.push({
            type: 'attribute',
            attributeName: Loop54ProductAttributes.InStock,
            value: onlyShowInStock,
        });
    }

    return useBrandEntities(
        {
            resultsOptions: {
                filter: {
                    and: filters,
                },
                sortBy: [{ type: 'popularity' }],
                take: 10,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
